export default __webpack_public_path__ + "3d48465acba919bf0ae34aa32a1be433.png";